import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const aiAgents = accountId => ({
  parentNav: 'aiAgents',
  routes: [
    'ai_agents_list',
    'ai_agent_new',
    'ai_agent_edit',
  ],
  menuItems: [
    {
      icon: 'bot',
      label: 'AI_AGENTS',
      hasSubMenu: true,
      toState: frontendURL(`accounts/${accountId}/ai-agents`),
      toStateName: 'ai_agents_list',
      featureFlag: FEATURE_FLAGS.AI_AGENTS,
    }
    
  ],
});

export default aiAgents; 
